'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteQueryResults', ['$controller', 'NotesQueryManagementService', 'NotesStore',
      function ($controller, NotesQueryManagementService, NotesStore) {

      return {
        templateUrl: 'views/directives/notes/saNoteQueryResults.html',
        restrict: 'A',
        scope: {
          queryName: '@',
          managementId: '@',
          hideOnEmpty: '@',
          onlyAllow: '@'
        },
        controllerAs: 'noteResultsCtrl',
        link: function (scope) {
          var baseCtrl = $controller('BaseQuerySubscriptionCtrl', {$scope: scope});

          scope.state = {
            q: {},
            notes: null,
            queryName: scope.queryName,
            managementId: scope.managementId,
            allowedRelations: (scope.onlyAllow) ? scope.onlyAllow.split(',') : []
          };

          function filterNotes(notes) {
            return lodash.filter(notes, function(note) {
              var rel = lodash.find(note.notes_relations, { active: true });

              // it is possible that if a note is deleted that rel is undefined due to there being no active relation
              return rel && (lodash.includes(scope.state.allowedRelations, rel.obj) || (lodash.includes(scope.state.allowedRelations, 'date') && rel.obj === null));
            });
          }

          function executeQuery() {
            console.log('Executing Query');
            scope.state.notes = null;

            NotesStore.getNotesForQuery(scope.state.currentQuery.query)
              .then(function(notes) {
                notes = [].concat(notes);
                var temp = lodash.sortBy(lodash.filter(notes, function(note) {
                  return lodash.isNull(note.parent_id);
                }), function(note) {
                  return -1 * note.created_at.unix();
                });

                if (scope.onlyAllow) {
                  temp = filterNotes(temp);
                }

                scope.state.notes = temp;
                console.log(' - Returned Notes:', scope.state.notes, scope.state.queryName, scope.state.managementId);
              }, function() {

              });

          }

          scope.$on('sa:notes:rerun-query', function() {
            executeQuery();
          });


          function update(currentQuery) {
            scope.state.currentQuery = {
              query: currentQuery
            };

            if (scope.state.currentQuery.query) {
              executeQuery();
            }
          }

          // Base ctrl
          baseCtrl.initialize(scope.state.queryName, scope.state.managementId);
          baseCtrl.setRenderCallback(update);
          baseCtrl.updateMyself();

          scope.state.updateChannel = baseCtrl.subscription.subject
            .filter(NotesQueryManagementService.genFilter(scope.state.managementId)).share();

          var notesSub = scope.state.updateChannel.filter(function(obj) {return obj.note;})
            .filter(function(objWithNote) {
              // check if the note gets past the current filterNotes fn
              if (filterNotes([objWithNote.note]).length === 0) {
                // if this note doesn't match the filter then don't refresh
                return false;
              }
              // check if the note is in the current list of notes
              var idx = lodash.findIndex(scope.state.notes, {id: objWithNote.note.id});
              return (!lodash.isNull(scope.state.notes) && idx < 0 && scope.state.currentQuery.query && scope.state.currentQuery.query.obj);
            })
            .debounce(100)
            .subscribe(function(x) {
              console.log('about to executeQuery', scope.state.queryName, scope.state.managementId, x)
              executeQuery();
            });

          scope.$on('$destroy', function() {
            console.log('$destroy -- saNoteQueryResults', scope.state.queryName, scope.state.managementId);
            baseCtrl.uninitialize();
            baseCtrl = undefined;
            notesSub.dispose();
          });
        }
      };
    }]);
